import React from "react";
import { Bar, BarButton, Spacer } from "./SelectionBar.styles";
import type { SelectionBarProps } from "./SelectionBar.types";

/** The bar over a selectable list: the count, bulk actions, and a quiet clear. */
export const SelectionBar: React.FC<SelectionBarProps> = ({ countLabel, actionsLabel, actions, clearLabel, onClear, className }) => (
  <Bar className={className} role="toolbar" aria-label={countLabel} data-testid="selection-bar">
    <span aria-live="polite">{countLabel}</span>
    {actionsLabel ? <span>{actionsLabel}</span> : null}
    {actions.map((a) => (
      <BarButton key={a.id} type="button" disabled={a.disabled} onClick={a.onClick}>
        {a.label}
      </BarButton>
    ))}
    <Spacer />
    <BarButton type="button" $quiet onClick={onClear}>
      {clearLabel}
    </BarButton>
  </Bar>
);

export default SelectionBar;
